import axios, { HttpStatusCode } from 'axios';
import {
  AuthServerError,
  TokenExpiredError,
  TokenInvalidError,
} from '../../corelogic/domain/errors/authentication.error';
import { AUTH_API_ERROR_MESSAGES } from '../../corelogic/domain/errors/gateway.errorMessages/authentication.error.messages';

//for all routes that use middleware, we need to handle the error
export const handleAuthError = (error: unknown): never => {
  if (axios.isAxiosError(error)) {
    switch (error.response?.status) {
      case HttpStatusCode.BadRequest:
        throw new TokenInvalidError(AUTH_API_ERROR_MESSAGES.INVALID_TOKEN);
      case HttpStatusCode.Unauthorized:
        throw new TokenExpiredError(AUTH_API_ERROR_MESSAGES.TOKEN_EXPIRED);
      default:
        throw new AuthServerError(AUTH_API_ERROR_MESSAGES.SERVER_ERROR);
    }
  }
  throw new AuthServerError(AUTH_API_ERROR_MESSAGES.SERVER_ERROR);
};
